import React, { useCallback } from 'react';
import { Button, Form, Input } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { Popup } from '../../lib/custom-ui';
import { withPopup } from '../../lib/popup';
import styles from './CompanyManageNumberEditPopup.module.scss';
import { useForm } from '../../hooks';

const CompanyManageNumberEditPopup = React.memo(({ usersLen, onUpdate, onClose }) => {
  const [data, handleFieldChange] = useForm(() => ({
    numberOfPeople: '',
  }));
  const handleSubmit = useCallback(() => {
    if (
      data.numberOfPeople === '' ||
      data.numberOfPeople === null ||
      data.numberOfPeople < usersLen
    ) {
      return;
    }
    onUpdate(data);
    onClose();
  }, [data, onClose, onUpdate, usersLen]);
  return (
    <>
      <Popup.Header>编辑企业人数</Popup.Header>
      <Popup.Content style={{ width: '284px' }}>
        <Form onSubmit={handleSubmit}>
          <div className={styles.text}>修改人数</div>
          <Input
            value={data.numberOfPeople}
            fluid
            name="numberOfPeople"
            placeholder="请输入人数上限"
            type="number"
            onChange={handleFieldChange}
            className={styles.field}
            min={3}
          />
          <Button positive content="修改" fluid />
        </Form>
      </Popup.Content>
    </>
  );
});

CompanyManageNumberEditPopup.propTypes = {
  usersLen: PropTypes.number.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withPopup(CompanyManageNumberEditPopup);
